import { writeException } from "../../lib/excepthook";
import { translated } from "../../lib/localize";

import { notifications } from "../../pyratFrontend";

export type ApiResponseType<T extends (...args: any) => Promise<any>> = Awaited<ReturnType<T>>["data"];
export type ApiRequestType<T extends (...args: any) => Promise<any>> = Parameters<T>[0];

export class ApiError extends Error {
    readonly name = "ApiError";

    constructor(
        readonly request: Request,
        readonly response: Response,
        readonly error: any,
    ) {
        super(JSON.stringify(error));
    }
}

/** Generic function to handle errors from the backend.
 *
 * @param callback - Function to call with the error message.
 * @param message - Default error message to show if the backend does not provide one.
 */
export const handleBackendError =
    ({
        callback = (error) => notifications.showNotification(error, "error"),
        message = translated("General error."),
    }: {
        callback?: (error: string) => void;
        message?: string;
    } = {}) =>
    (e: ApiError) => {
        if (e instanceof ApiError && typeof e?.error?.detail === "string") {
            // The backend gave a detailed error message.
            callback(e.error.detail);
            return;
        } else {
            // The backend returned an error, but no detailed message,
            // or it is some other exception.
            // This should not happen, but we can still show a general
            // error message and escalate the issue.
            callback(message);
            writeException(e);
            throw e;
        }
    };
